import React from "react";
import PlaceholderWeekRows from "./PlaceholderWeekRows";
import { PhosphorCaretLeftAnchor, PhosphorCaretRightAnchor } from "components/Atoms/PhosphorIconAnchor";

const PlaceholderCalendar = () => {
  const daysOfWeek = site.culture.firstDayOfWeek === 1 ? serverReference.abbreviatedDayLetters.slice(1).concat(serverReference.abbreviatedDayLetters[0]) : serverReference.abbreviatedDayLetters;

  return <div className="s1_panel show-list-calendar-wrapper">
    <div className="flex">
      <PhosphorCaretLeftAnchor
        layout="in-square" />

      <div className="grow1" style={{ textAlign: "center", cursor: "pointer" }}>&nbsp;</div>

      <PhosphorCaretRightAnchor
        layout="in-square" />
    </div>

    <div className="flex-column gap-mini">
      <div className="dayofweekrow">
        <div className="clear"></div>
        {daysOfWeek.map((day, idx) => <div key={idx} className="minicalendar_dayofweek">{day}</div>)}
      </div>
      <PlaceholderWeekRows />
    </div>
  </div>;
};

export default PlaceholderCalendar;